import useUserActiveApprovalWorkflowBlocks from './useUserActiveApprovalWorkflowBlocks'

export const useFirstUserActiveApprovalWorkflowBlock = () => useUserActiveApprovalWorkflowBlocks()?.[0]

export default useFirstUserActiveApprovalWorkflowBlock
